import speciesData from './species.json';
import factsData from './facts.json';
import questionsData from './questions.json';
import achievementsData from './achievements.json';
import journeysData from './journeys.json';
import sourcesData from './sources.json';

import type { OtterSpecies, Fact, Question, Achievement, Journey } from '@/types';

export const species: OtterSpecies[] = speciesData as OtterSpecies[];
export const facts: Fact[] = factsData as Fact[];
export const questions: Question[] = questionsData as Question[];
export const achievements: Achievement[] = achievementsData as Achievement[];
export const journeys: Journey[] = journeysData as Journey[];
export const sources = sourcesData;

// Helper functions
export function getSpeciesById(id: string): OtterSpecies | undefined {
  return species.find((s) => s.id === id);
}

export function getQuestionsForSpecies(speciesId: string): Question[] {
  return questions.filter((q) => q.relatedSpecies?.includes(speciesId));
}

export function getQuestionsForCategory(category: string): Question[] {
  return questions.filter((q) => q.category === category);
}

export function getQuestionsForDifficulty(difficulty: string): Question[] {
  return questions.filter((q) => q.difficulty === difficulty);
}

export function getFactsForSpecies(speciesId: string): Fact[] {
  return facts.filter((f) => f.relatedSpecies?.includes(speciesId));
}

export function getRandomFact(): Fact {
  return facts[Math.floor(Math.random() * facts.length)];
}

export function getRandomQuestion(difficulty?: string): Question {
  const filtered = difficulty
    ? questions.filter((q) => q.difficulty === difficulty)
    : questions;
  return filtered[Math.floor(Math.random() * filtered.length)];
}

export function getAchievementById(id: string): Achievement | undefined {
  return achievements.find((a) => a.id === id);
}

export function getJourneyById(id: string): Journey | undefined {
  return journeys.find((j) => j.id === id);
}

export function getJourneysForSpecies(speciesId: string): Journey[] {
  return journeys.filter((j) => j.type === 'species' && j.speciesId === speciesId);
}

export function shuffleArray<T>(array: T[]): T[] {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}
